module.exports = __webpack_public_path__ + "img/bg.3462f58e.jpg";